import type { FC } from 'react'

import resolveTailwindClasses from '@app/utils/resolveTailwindClasses'

type Props = {
  className?: string
  direction?: 'horizontal' | 'vertical'
}

export const GradientDivider: FC<Props> = ({ className, direction = 'horizontal' }) => (
  <div
    className={resolveTailwindClasses(
      'my-0.5 h-px min-h-px w-full',
      direction === 'horizontal' ? 'my-0.5 h-px min-h-px w-full' : 'mx-0.5 h-full w-px min-w-px',
      className
    )}
    style={{
      background: 'linear-gradient(90deg, rgba(36, 34, 74, 0.00) 0%, #24224A 50.24%, rgba(36, 34, 74, 0.00) 100%)'
    }}
  />
)
